import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { useAuth, formatApiError } from "@/contexts/AuthContext";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      const redirect = new URLSearchParams(loc.search).get("next") || "/account";
      nav(redirect, { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="bg-[#050505] text-white pt-32 min-h-screen">
      <div className="px-6 md:px-12 lg:px-24 pb-24 max-w-md mx-auto">
        <p className="eyebrow mb-4">Account</p>
        <h1 className="font-display text-4xl sm:text-5xl font-medium tracking-tight mb-2">
          Sign in
        </h1>
        <p className="text-zinc-400 mb-12 text-sm">
          Track orders and reorder for your next production.
        </p>

        <form onSubmit={submit} className="border border-white/10 bg-white/[0.02] p-8 space-y-6">
          <div>
            <label className="eyebrow mb-2 block">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-white text-white px-0 py-3 focus:outline-none"
              placeholder="you@church.org"
            />
          </div>
          <div>
            <label className="eyebrow mb-2 block">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-white text-white px-0 py-3 focus:outline-none"
            />
          </div>
          {err && <p data-testid="login-error" className="text-sm text-red-400">{err}</p>}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : <>Sign in <ArrowRight className="w-4 h-4" /></>}
          </button>
          <p className="text-sm text-zinc-500 text-center">
            <Link to="/forgot-password" data-testid="login-forgot-link" className="text-zinc-300 hover:text-white underline">
              Forgot your password?
            </Link>
          </p>
        </form>

        <p className="text-sm text-zinc-500 mt-8 text-center">
          New here?{" "}
          <Link to="/signup" data-testid="login-to-signup-link" className="text-white underline">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
